import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_13 = { class: "control-label col-sm-6" }
const _hoisted_14 = { class: "col-sm" }
const _hoisted_15 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_16 = { class: "control-label col-sm-6" }
const _hoisted_17 = { class: "col-sm" }
const _hoisted_18 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_19 = { class: "control-label col-sm-6" }
const _hoisted_20 = { class: "col-sm" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_23 = { class: "control-label col-sm-6" }
const _hoisted_24 = { class: "col-sm" }
const _hoisted_25 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_26 = { class: "control-label col-sm-6" }
const _hoisted_27 = { class: "col-sm" }
const _hoisted_28 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_29 = { class: "control-label col-sm-6" }
const _hoisted_30 = { class: "col-sm" }
const _hoisted_31 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_32 = { class: "control-label col-sm-6" }
const _hoisted_33 = { class: "col-sm" }

import { watch , ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo'
import FormAltroHelper from "../../pages/preventivi/json/altro/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormAltroProcure',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo()
const props = __props
const emits = __emit
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
switch (props.formName) {
  case 'procuraSpecialeRilasciata':
    validazione = categorieValidazione.categoriaAltro['sottocategoriaProcure']['procuraSpecialeRilasciata']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAltro['sottocategoriaProcure']['procuraSpecialeRilasciata']
    break
  case 'procuraGenerale':
    validazione = categorieValidazione.categoriaAltro['sottocategoriaProcure']['procuraGenerale']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAltro['sottocategoriaProcure']['procuraGenerale']
    break
  case 'revocaDiProcura':
    validazione = categorieValidazione.categoriaAltro['sottocategoriaProcure']['revocaDiProcura']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAltro['sottocategoriaProcure']['revocaDiProcura']
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormAltroHelper.sottocategoriaProcure[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if (validazione) {
  validazione.tipo_preventivo.value = 'altro/procure/' + props.tipoPreventivo.data.url
}
function tipo (event) {
  if (event.target.value === 'con_immobili') {
    validazione.numero_conservatorie.value = ''
    validazione.numero_conservatorie.required = true
  } else {
    validazione.numero_conservatorie.value = ''
    validazione.numero_conservatorie.required = false
  }
}
function tipoProcura (event) {
  if (event.target.value === 'generale_conservata_societaria') {
    validazione.tipo_societa.value = '';
    validazione.tipo_societa.required = true
  } else {
    validazione.tipo_societa.value = '';
    validazione.tipo_societa.required = false
  }
}
function tipoRevoca (event) {
  if (event.target.value === 'generale_conservata_societaria') {
    validazione.tipo_societa.value = '';
    validazione.tipo_societa.required = true
  } else {
    validazione.tipo_societa.value = '';
    validazione.tipo_societa.required = false
  }
}
watch(validazione, () => {
  emits('changeDatiPreventivo')
}, { deep: true })
let indexHelperClosing = {
  calcolo: FormAltroHelper.sottocategoriaProcure[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'procuraSpecialeRilasciata')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},
            {name: 'Privato', value: 'privato'}
            ],
                isSelected: _unref(validazione).forma_del_titolo.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "numero_marche_da_bollo",
                name: "numero_marche_da_bollo",
                class: "placeholder-right crm:text-right",
                placeholder: "Indicare numero marche da bollo",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).numero_marche_da_bollo,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) === 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly,
            "filter-options-d": true
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'procuraGenerale')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_13, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipo_di_procura.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_di_procura.ref]
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_base_select, {
                  name: "tipo_di_procura",
                  options: [{name: 'Generale Conservata', value: 'generale_conservata'},
            {name: 'Generale conservata societaria', value: 'generale_conservata_societaria'}
            ],
                  isSelected: _unref(validazione).tipo_di_procura.value !== '',
                  onChange: _cache[3] || (_cache[3] = $event => (tipoProcura($event))),
                  state: __props.readonly === true ?'disable':'',
                  validateTo: _unref(validazione).tipo_di_procura,
                  "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).tipo_di_procura) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(validazione).tipo_di_procura.value === 'generale_conservata_societaria')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_base_select, {
                      name: "tipo_societa",
                      options: [{name: 'Ditte individuali', value: 'ditte_individuali'},
                       {name: 'Società di capitali', value: 'societa_di_capitali'},
                       {name: 'Società di persone', value: 'societa_di_persone'}],
                      state: __props.readonly === true ?'disable':'',
                      isSelected: _unref(validazione).tipo_societa.value !== '',
                      validateTo: _unref(validazione).tipo_societa,
                      "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).tipo_societa) = $event))
                    }, null, 8 /* PROPS */, ["state", "isSelected", "validateTo"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_unref(regimeFiscale) === 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly,
              "filter-options-d": true
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'revocaDiProcura')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tipo_di_revoca.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_di_revoca.ref]
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_base_select, {
                    name: "tipo_di_revoca",
                    options: [{name: 'Generale Conservata', value: 'generale_conservata'},
            {name: 'Generale conservata societaria', value: 'generale_conservata_societaria'}
            ],
                    isSelected: _unref(validazione).tipo_di_revoca.value !== '',
                    onChange: _cache[7] || (_cache[7] = $event => (tipoRevoca($event))),
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).tipo_di_revoca,
                    "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).tipo_di_revoca) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              (_unref(validazione).tipo_di_revoca.value === 'generale_conservata_societaria')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_26, [
                      _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_base_select, {
                        name: "tipo_societa",
                        options: [{name: 'Ditte individuali', value: 'ditte_individuali'},
                       {name: 'Società di capitali', value: 'societa_di_capitali'},
                       {name: 'Società di persone', value: 'societa_di_persone'}],
                        isSelected: _unref(validazione).tipo_societa.value !== '',
                        state: __props.readonly === true ?'disable':'',
                        validateTo: _unref(validazione).tipo_societa,
                        "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).tipo_societa) = $event))
                      }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_28, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_29, [
                  _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_base_select, {
                    name: "forma_del_titolo",
                    options: [{name: 'Pubblico', value: 'pubblico'},
            {name: 'Privato', value: 'privato'}
            ],
                    isSelected: _unref(validazione).forma_del_titolo.value !== '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).forma_del_titolo,
                    "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              (_unref(regimeFiscale) === 'ordinario')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                        name: "ritenuta_acconto",
                        label: "Si, applicabile",
                        "validate-to": _unref(validazione).ritenuta_acconto,
                        "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                      }, null, 8 /* PROPS */, ["class", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly,
                "filter-options-d": true
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}